import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface BranchStatusRequest {
    branch_type: number;
    customer_branch_idx: number;
    branch_idx: number | null;
    branch_req?: string;
    branch_product_idx?: number[];
    del_file_idx?: number[];
    branch_product_image?: File[];
}

interface ApiErrorResponse {
    statusCode: number;
    message: string;
}

export const usePutBranchStatus = (
    successCallback?: () => void,
    orderIdx?: number,
): UseMutationResult<null, AxiosError<ApiErrorResponse>, BranchStatusRequest, unknown> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, AxiosError<ApiErrorResponse>, BranchStatusRequest>({
        mutationFn: async data => {
            try {
                const formData = new FormData();
                formData.append("branch_type", data.branch_type.toString());
                formData.append("customer_branch_idx", data.customer_branch_idx.toString());
                if (data.branch_type !== 1) {
                    if (data.branch_idx !== 0 && data.branch_idx !== null) {
                        formData.append("branch_idx", data.branch_idx.toString());
                    }
                    if (data.branch_idx === 0 && data.branch_idx !== null) {
                        formData.append("branch_idx", "null");
                    }
                }

                if (data.branch_req) formData.append("branch_req", data.branch_req ?? "");

                if (data.branch_product_idx && data.branch_product_idx.length > 0) {
                    data.branch_product_idx.forEach(idx => {
                        formData.append("branch_product_idx", idx.toString());
                    });
                }

                if (data.del_file_idx) {
                    data.del_file_idx.forEach(idx => {
                        formData.append("del_file_idx", idx.toString());
                    });
                }

                if (data.branch_product_image?.length) {
                    data.branch_product_image.forEach(file => {
                        formData.append("branch_product_image", file);
                    });
                }

                const response = await axios.put(
                    `${enum_api_uri.put_order_branch.replace(":order_idx", orderIdx?.toString() || "")}`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["getOrderInfo"] });
            queryClient.invalidateQueries({ queryKey: ["getOrderList"] });
            successCallback?.();
        },
    });
};
